module.exports = __webpack_public_path__ + "img/introducePageTwo_show_seven.f7280d51.jpg";